var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeWhiteBelt4RedStripes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-ow4r-1{fill:#ff6700 !important;}.cls-ow4r-2{fill:#fff !important;}.cls-ow4r-3{fill:#14191d !important;}.cls-ow4r-4{fill:#e1251b !important;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    className: "cls-ow4r-1",
    d: "M0,0H207a8,8,0,0,1,8,8V45a8,8,0,0,1-8,8H0V0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    className: "cls-ow4r-2",
    y: 19.51,
    width: 215,
    height: 13.98
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-2",
    "data-name": "Rectangle 27",
    className: "cls-ow4r-3",
    x: 86,
    width: 108,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_1",
    "data-name": 1,
    className: "cls-ow4r-2",
    x: 170,
    width: 12,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_2",
    "data-name": 2,
    className: "cls-ow4r-2",
    x: 146,
    width: 12,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_3",
    "data-name": 3,
    className: "cls-ow4r-2",
    x: 122,
    width: 12,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_4",
    "data-name": 4,
    className: "cls-ow4r-2",
    x: 98,
    width: 12,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_1-2",
    "data-name": 1,
    className: "cls-ow4r-4",
    x: 170,
    width: 12,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_2-2",
    "data-name": 2,
    className: "cls-ow4r-4",
    x: 146,
    width: 12,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_3-2",
    "data-name": 3,
    className: "cls-ow4r-4",
    x: 122,
    width: 12,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_4-2",
    "data-name": 4,
    className: "cls-ow4r-4",
    x: 98,
    width: 12,
    height: 53
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeWhiteBelt4RedStripes);
export default __webpack_public_path__ + "static/media/Orange_White_Belt_4_Red_Stripes.9b0d5832636295f2a3934dddc887ba98.svg";
export { ForwardRef as ReactComponent };